import { render, staticRenderFns } from "./ButtonToAnswer.vue?vue&type=template&id=573ff2a9&"
import script from "./ButtonToAnswer.vue?vue&type=script&lang=js&"
export * from "./ButtonToAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports